import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import Cookies from 'js-cookie';
import "./subscription_plan.css";

const SubscriptionPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);

  const planDetails = {
    MONTHLY: { name: "Monthly Plan", amount: 99 },
    YEARLY: { name: "Yearly Plan", amount: 499 }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => setRazorpayLoaded(true); // ✅ Script load hone ke baad state update
    document.body.appendChild(script);
  }, []);

  const handleProceedToPayment = async () => {
    if (!selectedPlan) {
      alert("Please select a plan!");
      return;
    }
    if (!razorpayLoaded) {
      alert("Payment gateway is still loading. Please wait!");
      return;
    }

    try {
      setLoading(true);
      const user = await Auth.currentAuthenticatedUser();
      const username = user.username;
      const planId = selectedPlan.toLowerCase();
      
      const getToken = async () => {
          try {
            const user = await Auth.currentAuthenticatedUser(); 
            const session = await Auth.currentSession();
            // const accessToken = session.getAccessToken();
            // const jwt = accessToken.getJwtToken();
            const jwt = session.getIdToken().getJwtToken();
            const usernameOrEmail = user.username.includes("Google_")
              ? user.attributes.email
              : user.username;
      
            return [usernameOrEmail, jwt]; // ✅ Return both values
          } catch (error) {
            // console.log("Auth error:", error);
            await Auth.signOut();
            return [null, null]; // Fallback return
          }
        };
      const [Username, jwt] = await getToken(); // ✅ Destructure correctly
     
      if (!username || !jwt) return; // Prevent call if something failed
      const response = await fetch("https://api.quizwizard.net/quiz/razorpay_order_api", {
        method: "POST",
        headers: { "Content-Type": "application/json",
          'Authorization': jwt,
         },
        body: JSON.stringify({
          plan_id: planId,
          // amount: planDetails[selectedPlan].amount * 100, // Convert ₹ to paise
          username: username
        })
      });
      // console.log("Response:", response); // ✅ Debugging line
      const data = await response.json();
      
      if (!data.order_id) throw new Error("Order creation failed");

      const options = {
        key: "rzp_test_qoxb6Zl0U4bglh",
        amount: data.amount,
        currency: "INR",
        name: "Gencoft Technologies",
        description: `${planDetails[selectedPlan].name} Subscription Payment`,
        order_id: data.order_id,
        handler: function (response) {
          // console.log("Payment Success Response: ", response);
          if (!response.razorpay_payment_id) {
            alert("Payment verification failed.");
            return;
          }
          // alert("Payment successful!");
          Cookies.set('questionsPracticed', 0); // Reset cookie to 0
          history.push("/practiceevents");
        },
        theme: { color: "#3399cc" }
      };

      const razorpayInstance = new window.Razorpay(options);
      razorpayInstance.open();

    } catch (error) {
      alert("Payment failed, please try again.");
      // console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-container">
      <h1 className="subscription-title">Choose Your Subscription Plan</h1>
      <div className="subscription-plans">
        {["MONTHLY", "YEARLY"].map((planType) => (
          <div
            key={planType}
            className={`plan-card ${selectedPlan === planType ? "selected" : ""}`}
            onClick={() => setSelectedPlan(planType)}
          >
            <h2 className="plan-title">{planDetails[planType].name}</h2>
            <p className="plan-price">
              ₹{planDetails[planType].amount} {planType === "MONTHLY" ? "/month" : "/year"}
            </p>
          </div>
        ))}
      </div>
      <div className="payment-section">
        <button
          className="proceed-button"
          disabled={!selectedPlan || loading}
          onClick={handleProceedToPayment}
        >
          {loading ? "Processing..." : "Proceed to Payment"}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionPage;